module.exports = __webpack_public_path__ + "static/media/aceshades-5.872ac80a.png";